import { Canvas } from '@react-three/fiber';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import { useState } from 'react';
import { Lock3D } from './Lock3D';
import { Tools } from './Tools';
import { SimulatorUI } from './SimulatorUI';

export function LockSimulator() {
  const [lockState, setLockState] = useState({
    rotation: 0,
    pinsLifted: [false, false, false, false, false],
    selectedTool: 'pick',
    difficulty: 'medium',
    isOpen: false,
    feedback: '',
  });

  return (
    <div className="relative w-full h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <Canvas>
        <PerspectiveCamera makeDefault position={[0, 0, 8]} />
        <OrbitControls
          enableZoom
          enablePan
          autoRotate={false}
          minDistance={5}
          maxDistance={15}
        />

        {/* Lighting */}
        <ambientLight intensity={0.6} />
        <directionalLight position={[10, 10, 5]} intensity={0.8} castShadow />
        <pointLight position={[-5, 5, 5]} intensity={0.4} color="#ffffff" />

        {/* Lock and tools */}
        <Lock3D lockState={lockState} />
        <Tools selectedTool={lockState.selectedTool} lockState={lockState} />
      </Canvas>

      {/* UI Overlay */}
      <SimulatorUI lockState={lockState} setLockState={setLockState} />
    </div>
  );
}
